import React, { useRef, useState } from 'react';
import { Avatar, Button, Form, Input, Modal, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { fetchModifyUserInfo, fetchUserInfo } from '@/apis/user';
import { uploadAvatar } from '@/apis/uploads';
import { getRequestErrorMessage } from '@/utils/requestError';
import { setUserInfo } from '@/store/modules/user';
import ImagePicker from '@/components/imagepicker';
import DialogHeading from '@/components/dialogheading';
import './ProfileEditors.scss';

const EditAvatarModal = ({ avatarOpen, setAvatarOpen }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.user.userInfo);
  const [form] = Form.useForm();
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const save = async values => {
    if (lock.current) return;
    lock.current = true; setBusy(true);
    try {
      if (files.length) {
        const result = await uploadAvatar(files[0].originFileObj || files[0]);
        if (!result?.avatar || !result.user?.id) throw new Error('头像上传响应无效');
        dispatch(setUserInfo(result.user));
      } else {
        const result = await fetchModifyUserInfo(values, userInfo.username);
        if (!result?.success) throw new Error(result?.error || '头像修改失败');
        await dispatch(fetchUserInfo());
      }
      setFiles([]); setAvatarOpen(false); message.success('头像修改成功');
    } catch (err) { message.error(getRequestErrorMessage(err, err.message || '头像修改失败')); }
    finally { lock.current = false; setBusy(false); }
  };
  return <Modal className="profileEditor-modal" centered width={520} open={avatarOpen} title={<DialogHeading icon={<UserOutlined />} title="修改头像" description="选择一张喜欢的图片，展示你的个人风格" />} footer={null} destroyOnHidden maskClosable={!busy} closable={!busy} keyboard={!busy}
    onCancel={() => { if (!busy) { setFiles([]); setAvatarOpen(false); } }}>
    <Form form={form} layout="vertical" disabled={busy} initialValues={{ avatar: userInfo.avatar || '' }} clearOnDestroy onFinish={save}>
      <div className="profileEditor-avatar"><Avatar size={64} src={userInfo.avatar || undefined} icon={<UserOutlined />} /><div><strong>当前头像</strong><p>可上传本地图片，或填写图片链接</p></div></div>
      <Form.Item label="上传头像"><ImagePicker files={files} onChange={setFiles} maxCount={1} maxMiB={5} disabled={busy} /></Form.Item>
      <Form.Item name="avatar" label="或使用图片链接" rules={[{ type: 'url', message: '请输入有效的图片链接' }]} extra="选择本地图片后，将优先上传本地图片。"><Input disabled={busy || files.length > 0} placeholder="https://…" /></Form.Item>
      <div className="dialogForm-actions"><Button disabled={busy} onClick={() => { setFiles([]); setAvatarOpen(false); }}>取消</Button><Button type="primary" htmlType="submit" loading={busy}>保存头像</Button></div>
    </Form>
  </Modal>;
};
export default EditAvatarModal;
